export default __webpack_public_path__ + "static/media/Royal Signet.66dab54c.jpg";